<template>
    <div>
        <header class="page-header">
            <h2>
                <a href=""></a>
            </h2>
            <ol class="breadcrumbs">
                <li class="active">
                    <span>Infraestructura</span>
                </li>
            </ol>
        </header>
        <div class="row">
            <div class="col-md-3">
                <section class="card card-featured-left card-featured-primary mb-4">
                    <div class="card-body">
                        <div class="widget-summary widget-summary-md">
                            <div class="widget-summary-col widget-summary-col-icon">
                                <div class="summary-icon text-secondary">
                                    <div class="progress1 mx-auto">

                    <span class="progress1-left">
                    <span class="progress1-bar border-primary" :style="progressLeftStyle(disc_used_)"></span>
                    </span>
                                        <span class="progress1-right">
                    <span class="progress1-bar border-primary" :style="progressRightStyle(disc_used_)"></span>
                    </span>
                                        <div class="progress1-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
                                            <div class="font-weight-bold">{{ disc_used_ }}<small class="small"></small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-summary-col">
                                <div class="summary">
                                    <h4 class="title"><!-- Disco <br> Duro --></h4>
                                    <div class="info">
                                        <strong class="amount">Disco Duro</strong><br>
                                        <!-- <span class="text-warning" v-if="discUsed == 0">no se pudo obtener</span> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div class="col-md-3">
                <section class="card card-featured-left card-featured-primary mb-4">
                    <div class="card-body">
                        <div class="widget-summary widget-summary-md">
                            <div class="widget-summary-col widget-summary-col-icon">
                                <div class="summary-icon text-secondary">
                                    <div class="progress1 mx-auto">

                    <span class="progress1-left">
                      <span class="progress1-bar border-primary" :style="progressLeftStyle(i_used_)"></span>
                    </span>
                                        <span class="progress1-right">
                      <span class="progress1-bar border-primary" :style="progressRightStyle(i_used_)"></span>
                    </span>
                                        <div class="progress1-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
                                            <div class="font-weight-bold">{{ i_used_ }}<small class="small"></small></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-summary-col">
                                <div class="summary">
                                    <h4 class="title"><!-- Disco <br> Duro --></h4>
                                    <div class="info">
                                        <strong class="amount">Inodes</strong>
                                        <!-- <span class="text-primary">(14 unread)</span> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div class="col-md-3">
                <section class="card card-featured-left card-featured-primary mb-4">
                    <div class="card-body">
                        <div class="widget-summary widget-summary-md">
                            <div class="widget-summary-col widget-summary-col-icon">
                                <div class="summary-icon text-secondary">
                                    <div class="progress1 mx-auto"
                                         data-value='100'>
                    <span class="progress1-left">
                      <span class="progress1-bar border-tertiary"></span>
                    </span>
                                        <span class="progress1-right">
                      <span class="progress1-bar border-tertiary"></span>
                    </span>
                                        <div class="progress1-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
                                            <div class="font-weight-bold">{{ loading_storage ? '...' : storage_size_ }}<small class="small"></small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-summary-col">
                                <div class="summary">
                                    <h4 class="title"><!-- Disco <br> Duro --></h4>
                                    <div class="info">
                                        <strong class="amount">Archivos <br> Generados</strong>
                                        <!-- <span class="text-primary">(14 unread)</span> -->
                                    </div>
                                </div>
                                <div class="summary-footer">
                                    <!-- <a class="text-muted text-uppercase">(view all)</a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div class="col-md-3">
                <section class="card card-featured-left card-featured-primary mb-4">
                    <div class="card-body">
                        <div class="widget-summary widget-summary-md">
                            <div class="widget-summary-col widget-summary-col-icon">
                                <div class="summary-icon"
                                     style="background-color: #292961">
                                    <i class="fab fa-gitlab"></i>
                                </div>
                            </div>
                            <div class="widget-summary-col">
                                <div class="summary">
                                    <h4 class="title"><!-- Disco <br> Duro --></h4>
                                    <div class="info">
                                        <strong class="amount">Versión</strong><br>
                                        <span class="text-primary">{{ version_text }}</span>
                                    </div>
                                </div>
                                <div class="summary-footer">
                                    <!-- <a class="text-muted text-uppercase">(view all)</a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <div class="col-12">
                <server-status></server-status>
            </div>
        </div>
    </div>
</template>

<script>
    import ServerStatus from '../configuration/server_status.vue'
    
    export default {
        name: "InfraestructureIndex",
        components: {
            ServerStatus
        },
        data() {
            return {
                disc_used_: 0,
                i_used_: 0,
                storage_size_: 0,
                version_text: '',
                loading_storage: false,
            }
        },
        mounted() {
            // se lanzan en paralelo, la carga de storage no bloquea al resto
            this.getStatistics()
            this.getStorageSize()
        },
        methods: {
            getStatistics() {
                this.$http.get(`/systems/statistics`)
                    .then(response => {
                        this.disc_used_ = response.data.disc_used
                        this.i_used_ = response.data.i_used
                        this.version_text = response.data.version
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            getStorageSize() {
                this.loading_storage = true
                this.$http.get(`/systems/storage_size`)
                    .then(response => {
                        this.storage_size_ = response.data.success ? response.data.storage_size : 'N/D'
                    })
                    .catch(() => {
                        this.storage_size_ = 'N/D'
                    })
                    .finally(() => this.loading_storage = false)
            },
            toPercentage(value) {
                // df devuelve " 45%" o "12%", se limpia a número entre 0 y 100
                const number = parseInt(value)
                return isNaN(number) ? 0 : Math.min(Math.max(number, 0), 100)
            },
            progressRightStyle(value) {
                // lado derecho cubre de 0 a 50%
                const percentage = Math.min(this.toPercentage(value), 50)
                return { transform: `rotate(${percentage / 100 * 360}deg)` }
            },
            progressLeftStyle(value) {
                // lado izquierdo cubre de 50 a 100%
                const percentage = Math.max(this.toPercentage(value) - 50, 0)
                return { transform: `rotate(${percentage / 100 * 360}deg)` }
            },
        },
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/system/infraestructure/index.vue